<!--
 * @Author: Ashley.Liu
 * @Date: 2022-03-14 13:36:10
 * @LastEditTime: 2022-07-11 18:36:09
 * @Description: desc
-->
<template>
  <div id="wrapper">
    <navbar v-if="standalone"></navbar>
    <div class="super-main-container">
      <div
        class="menu-container"
        id="menu-container"
      >
        <!-- <div
          class="menu-bar"
          style="margin-top: 4px;"
          v-if="standalone"
        >
          <zm-tabs
            type="pipeline"
            v-model="activeMenu"
            v-show="!isCollapse"
            stretch
          >
            <zm-tab-pane
              label="Classic"
              name="classic"
            >
            </zm-tab-pane>
            <zm-tab-pane
              label="Modern"
              name="modern"
            >
            </zm-tab-pane>
          </zm-tabs>
          <zm-button
            type="icon"
            icon="zm-icon-forward"
            v-if="isCollapse"
            @click="isCollapse = !isCollapse"
          ></zm-button>
          <zm-button
            type="icon"
            icon="zm-icon-backward"
            class="mgl-sm"
            v-if="!isCollapse"
            @click="isCollapse = !isCollapse"
          ></zm-button>
        </div> -->
        <!-- <sidebar
          v-if="activeMenu === 'classic' && !isUserMenu"
          :isCollapse="isCollapse"
          @switchMenu="switchMenu"
        />
        <user-sidebar v-if="activeMenu === 'classic' && isUserMenu" />
        <ModernMenu
          v-if="activeMenu === 'modern'"
          :isCollapse="isCollapse"
          @switchMenu="switchMenu"
          @mouseenter.native="toggleMenu('enter')"
          @mouseleave.native="toggleMenu('leave')"
        /> -->
        <AsMenu
          :menuConfig="menuList"
          height="calc(100vh - 50px)"
          :width="240"
          :router="true"
        ></AsMenu>
      </div>
      <div class="main-container">
        <div class="as-flex-row header">
          <breadcrumb style="flex: 1"></breadcrumb>
          <MultiTabs v-if="standalone"></MultiTabs>
          <div
            class="on-call"
            v-if="onCallName"
            v-clipboard:copy="onCallName"
            v-clipboard:success="onCopied"
            v-clipboard:error="onCopyFailed"
            style="color: #0E71EB"
          >
            <span>{{`Today's On Call:  ${onCallName}`}}</span>
          </div>
        </div>
        <app-main class="appmain-container" />
        <mq-footer></mq-footer>
      </div>
      <div class="empty"></div>
    </div>
    <!-- <sidebar></sidebar> -->
    <OperationGuide
      :elements="tooltipEls"
      :modules="tooltipModules"
    ></OperationGuide>
  </div>
</template>
<script>
import Navbar from './components/Navbar'
// import Sidebar from './components/Sidebar'
// import ModernMenu from './components/modernMenu'
// import UserSidebar from './components/UserSidebar'
import Breadcrumb from '@/components/Breadcrumb'
import AppMain from './components/AppMain'
import Footer from './components/Footer.vue'
import MultiTabs from '@/components/MultiTabs/tabs'
import OperationGuide from '@/components/OperationGuide'
import { listSchedule } from '@/api/guide'
import { adminMenu, userMenu, microAPPMenu } from './components/menu.config'
import cloneDeep from 'lodash/cloneDeep'
import { getMqType } from '@/api'
import { pagetips } from './components/pagetip.config'
export default {
  name: 'layout',
  components: {
    Navbar,
    // Sidebar,
    // ModernMenu,
    // UserSidebar,
    AppMain,
    Breadcrumb,
    'mq-footer': Footer,
    MultiTabs,
    OperationGuide
  },
  computed: {
    standalone () {
      return this.$root.standalone
    }
  },
  provide () {
    return {
      standalone: this.standalone
    }
  },
  data () {
    return {
      input: '',
      isUserMenu: ['SUPER_ADMIN', 'ADMIN', 'REVIEWER', 'READONLY'].indexOf(localStorage.role) === -1,
      isOldMenu: false,
      activeMenu: 'modern',
      isCollapse: false,
      onCallName: '',
      menuList: [],
      tooltipEls: [],
      tooltipModules: []
    }
  },
  watch: {
    '$route.path' () {
      // if dont't set setTimeout 200 ms, it will skew the position where the tooltip appears because the DOM element is not fully loaded
      setTimeout(() => {
        this.setGlobalPageTooltip()
      }, 200)
    }
  },
  created () {
    if (localStorage.cacheRouter) {
      this.$router.push(localStorage.cacheRouter)
      localStorage.cacheRouter = ''
    }
    this.isOldMenu = localStorage.isOldMenu
    this.listSchedule()
    const menuList = this.standalone ? cloneDeep(!this.isUserMenu ? adminMenu : userMenu) : cloneDeep(microAPPMenu)
    this.replaceChannelMenu(menuList)
  },
  mounted () {
    this.setGlobalPageTooltip()
  },
  methods: {
    /**
     * @desc if all page's tooltip has shown, return true
     */
    isTooltipHasFulleyShown () {
      const tooltipIsOk = Object.keys(JSON.parse(localStorage.getItem('tooltipIsOk') || '{}'))
      const pagetipModule = pagetips.map(x => x.module)
      if (pagetipModule.length !== tooltipIsOk.length) return false
      return pagetipModule.every(i => tooltipIsOk.includes(i))
    },
    setGlobalPageTooltip () {
      if (this.$route.path === '/login') return
      if (this.isTooltipHasFulleyShown()) return
      const tooltipIsOk = Object.keys(JSON.parse(localStorage.getItem('tooltipIsOk') || '{}'))
      let currentPageTip = pagetips.find(x => x.specifiedRoute === this.$route.path)
      const globalPageTips = pagetips.filter(x => x.specifiedRoute === false)
      let unShowGlobalPageTips = []
      let unShowGlobalPageTipsEl = []

      if (tooltipIsOk.length) {
        unShowGlobalPageTips = globalPageTips.filter(i => !tooltipIsOk.includes(i.module))
        unShowGlobalPageTipsEl = unShowGlobalPageTips.reduce((prev, curr) => prev.concat(curr.tooltipEls), [])
        if (!currentPageTip) return
        currentPageTip = tooltipIsOk.includes(currentPageTip.module) ? null : currentPageTip
      } else {
        unShowGlobalPageTips = globalPageTips
        unShowGlobalPageTipsEl = unShowGlobalPageTips.reduce((prev, curr) => prev.concat(curr.tooltipEls), [])
      }
      const tooltipEls = currentPageTip ? unShowGlobalPageTipsEl.concat(currentPageTip.tooltipEls) : unShowGlobalPageTipsEl
      this.tooltipModules = currentPageTip ? unShowGlobalPageTips.concat(currentPageTip).map(i => i.module) : unShowGlobalPageTips.map(i => i.module)

      if (tooltipEls.length) {
        this.tooltipEls = tooltipEls.map(x => {
          return {
            ...x,
            el: document.body.querySelector(x.el)
          }
        })
      } else {
        this.tooltipModules = []
        this.tooltipEls = []
      }
    },
    switchMenu () {
      this.isOldMenu = !this.isOldMenu
      localStorage.isOldMenu = this.isOldMenu
    },
    toggleMenu (type) {
      if (type === 'enter') {
        this.timer = setTimeout(() => {
          if (this.isCollapse) this.isCollapse = false
        }, 500)
      } else {
        if (this.timer) {
          clearTimeout(this.timer)
        }
      }
    },
    listSchedule () {
      listSchedule().then(response => {
        this.onCallName = sessionStorage.onCall = response?.[0]?.name
      })
    },
    async replaceChannelMenu (menuList) {
      this.menuList = menuList
      try {
        const channelName = await getMqType()
        menuList.map(({ children = [] }) => {
          const fn = (item) => { if (item.replaced === 'channel') { item.name = channelName } }
          children.map((cd) => {
            fn(cd)
            cd?.children?.map((item) => {
              fn(item)
            })
          })
        })
      } finally {
        this.menuList = menuList
      }
    },
    onCopied () {
      this.$message.success('Copied!')
    },
    onCopyFailed () {
      this.$message.success('Copy Failed!')
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "@/styles/variable.scss";
.menu-container {
  // border-right: 1px solid #d8dce5;
  // height: calc(100vh - #{$asyncmq-navbar-height});
  overflow: hidden;
  // background: #f7f7fa;
  // .menu-bar {
  //   display: flex;
  //   justify-content: flex-end;
  //   align-items: flex-start;
  // }

  // ::v-deep .zm-tabs {
  //   margin-bottom: 0;
  //   border-bottom: none;
  //   margin-left: 23px;
  //   width: 203px;
  // }
  ::v-deep {
    .zm-menu-item {
      padding: 0;
    }
    .as-menu .zm-menu .zm-menu-item .zm-tooltip [class^="iconfont"] {
      margin-left: -4px;
    }
  }
}
.on-call {
  cursor: pointer;
  background: transparent;
  position: fixed;
  right: 0;
  bottom: 0px;
  font-family: "SF Pro Text";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  color: #6e7680;
  padding-top: 8px;
  padding-right: 30px;
  z-index: 3000;
  text-decoration: underline;
}
</style>
